import script from "./Expert.vue?vue&type=script&setup=true&lang=ts"
export * from "./Expert.vue?vue&type=script&setup=true&lang=ts"

import "./Expert.vue?vue&type=style&index=0&id=61ad81f9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61ad81f9"]])

export default __exports__